<template>
  <main class="mt-5">
    <div class="card border-0 mt-3">
      <div class="card-header border-0 d-print-none justify-content-between">
        <h5 class="card-title font-bold py-3">فیلتر تامین کننده </h5>
        <span id="order-print" v-if="reports.finalReports && reports.finalReports.length>0">
          <button @click="printOrder()" class="btn btn-info ml-2 btn-print">
          <i class="fe fe-printer"></i>
          </button>
         </span>
        <b-tooltip target="order-print" triggers="hover"> چاپ</b-tooltip>
      </div>

      <div class="card-body border-0 d-print-none">
        <BForm class="row justify-content-between align-items-center">
          <div class="col-md-4 mb-2">
            <DatePickerRange
                newFormat="YYYY-MM-DD HH:mm"
                newFormatShow="jYYYY-jMM-jDD HH:mm"
                v-model="filter.date"
            />
          </div>
          <div class="col-md-4 d-flex align-items-baseline w-100 " v-if="providersList.length > 0">
            <label class="-25 mb-0" for="">تامین کننده :</label>
            <div class="w-75">
              <b-form-group>
                <multiselect
                    placeholder="تامین کننده"
                    v-model="filter.providers"
                    :options="providersList"
                    :searchable="true"
                    :close-on-select="true"
                    :show-labels="false"
                    open-direction="bottom"
                    label="full_name"
                    track-by="id"
                >
                  <template slot="noOptions">
                    موردی یافت نشد
                  </template>
                  <template slot="noResult">
                    موردی یافت نشد
                  </template>
                </multiselect>
              </b-form-group>
            </div>
          </div>
          <div class="col mr-auto mb-2">
            <BButton @click="loadData" variant="primary">فیلتر سازی</BButton>
          </div>
        </BForm>

      </div>
      <b-tooltip v-if="!hasPermission('write_product')" target="add-btn" triggers="hover">
        شما به این بخش دسترسی ندارید
      </b-tooltip>
      <div v-else>
        <div class="card-footer border-0" v-if="reports.finalReports&&reports.finalReports.length">
          <section class="mt-5">
            <div v-for="(item , index) in reports.finalReports" :class="`${index==0 ? 'pt-0 pb-3' :'py-3' }`">
              <table class="table table-bordered">
                <thead>
                <tr class="table-dark">
                  <th scope="col" class="border border-dark" v-for="item in titles" :key="item.label">{{
                      item.label
                    }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(innerItem,innerIndex) in item.varietiesReport">
                  <th class="border border-dark" scope="row" v-if="innerIndex==0"
                      :rowspan="item.varietiesReport.length">
                    {{ item.productTitle }}
                  </th>
                  <td class="border border-dark">{{ innerItem.varietyFullTitle }}</td>
                  <td class="border border-dark">{{ innerItem.firstBalance }}</td>
                  <td class="border border-dark">{{ innerItem.onlineOrderSellCount }}</td>
                  <td class="border border-dark">{{ innerItem.miniOrderSellCount }}</td>
                </tr>
                <tr class="table-dark" v-if="item.varietiesReport && item.varietiesReport.length">
                  <th class="text-dark border border-dark" colspan="2">جمع کل</th>
                  <td class="text-dark border border-dark">{{
                      sumTotalCalculator(item.varietiesReport).firstBalance
                    }}
                  </td>
                  <td class="text-dark border border-dark">{{
                      sumTotalCalculator(item.varietiesReport).onlineOrderSellCount
                    }}
                  </td>
                  <td class="text-dark border border-dark">{{
                      sumTotalCalculator(item.varietiesReport).miniOrderSellCount
                    }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
        <div>
          <Loading v-if="loading"/>
          <div v-if="!loading&&(reports.finalReports && reports.finalReports.length==0) "
               class="alert alert-danger">
            موردی یافت نشد
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {BButton, BForm, BFormGroup, BFormInput, BTable, BTooltip, VBToggle, VBTooltip} from "bootstrap-vue";
import {priceFilter} from "@@/core/libraries/filters";

import {
  getStatusLabel,
  getStatusColor,
} from "@@/core/libraries/adminFunctions";
import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
import sortMixin from "@@/core/libraries/mixins/sortMixin";
import {Treeselect} from "@riophae/vue-treeselect";
import TreeselectAddable from "@@/core/components/product/shared/TreeselectAddable/TreeselectAddable";
import Loading from "@@/core/components/shared/Loading/Loading";

export default {
  name: "OrdersReport",
  components: {
    Loading,
    DatePickerRange,
    BTable,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BTooltip,
    Treeselect,
    TreeselectAddable
  },
  mixins: [sortMixin],
  directives: {
    "b-toggle": VBToggle,
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      totals: null,
      ordersInfo: null,
      attributesInfo: null,
      searchParams: {},
      providersList: [],
      loading: false,
      page: 1,
      titles: [
        {
          label: "عنوان",
        },
        {
          label: "تنوع",
        },
        {
          label: "موجودی اولیه",
        },
        {
          label: "فروش آنلاین",
        },
        {
          label: "فروش حضوری",
        },
      ],
      previousPage: 1,
      per_page: 50,
      disabled: true,
      reports: {},
      filter: {
        date: {
          startDate: "",
          endDate: "",
        },
        providers: "",
      },
    };
  },
  async mounted() {
    await this.fetchProvider()
  },
  watch: {
    per_page() {
      this.changePage(1);
    },
    // '$route': function (newVal) {
    //   if (newVal) {
    //     this.filter.date.start_date = this.$route.query.start_date;
    //     this.filter.date.end_date = this.$route.query.end_date;
    //     this.filter.providers = this.providersList?.filter(item => item.id === this.$route.query.provider_id)[0];
    //   }
    // },
    'providersList': (newvalue) => {
      if (newvalue) {
        if (this.$route.query && this.$route.query.provider_id) {
          this.filter.providers = this.providersList?.filter(item => item.id === this.$route.query.provider_id)[0];
        }
        if (this.providersList.length) {
          this.loadData()
        }
      }
    }
  },

  methods: {
    getStatusLabel,
    getStatusColor,
    showAttributesInfo(report) {
      this.attributesInfo = report.attribute_info;
      this.$root.$emit("bv::show::modal", "attributes-info");
    },
    async loadData() {
      console.log(this.filter.date)
      const query = {
            start_date: this.filter.date.startDate.length ? this.filter.date.startDate : "",
            end_date: this.filter.date.endDate.length ? this.filter.date.endDate : "" ,
            provider_id: this.filter.providers && this.filter.providers.id ? this.filter.providers.id : "",
      }
      for (let key in query) {
        if (!query[key].length) {
          delete query[key];
        }
      }
      this.$router.replace({query})
      try {
        this.disabled = true;
        this.loading = true;
        const response = await this.$axios.get("/admin/accounting/cardex_report", {
          params: {
            start_date: this.filter.date.startDate,
            end_date: this.filter.date.endDate,
            provider_id: this.filter.providers && this.filter.providers.id ? this.filter.providers.id : "",
          },
        });
        // this.reports = response.data.data.orders;
        this.reports = response.data.data;
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
        this.loading = false;
      }
    },
    sumTotalCalculator(items) {
      const total = {
        miniOrderSellCount: [],
        onlineOrderSellCount: [],
        firstBalance: [],
      }
      items.forEach(item => {
        total.miniOrderSellCount.push(Number(item.miniOrderSellCount))
        total.onlineOrderSellCount.push(Number(item.onlineOrderSellCount))
        total.firstBalance.push(Number(item.firstBalance))
      });
      const sums = {};

      Object.keys(total).forEach(key => {
        sums[key] = total[key].reduce((acc, num) => acc + num, 0);
      });
      return sums;
    },
    async filterItem() {
      this.searchParams = {
        "end_date": this.filter.endDate,
        "start_date": this.filter.startDate,
        "provider_id": (this.filter.providers && this.filter.providers.id) ? this.filter.providers.id : "",
      };
      this.$router.replace({query: this.searchParams})
    },
    async fetchProvider() {
      try {
        this.loading = true
        const response = await this.$axios.get("admin/products/create");
        this.providersList = response.data.data.providers;
        if (this.providersList.length && this.$route.query && Object.keys(this.$route.query).length) {
          console.log(this.$route.query,'this.$route.query')
          this.filter.date.start_date = this.$route.query.start_date;
          this.filter.date.end_date = this.$route.query.end_date;
          this.filter.providers = this.providersList?.filter(item => item.id === this.$route.query.provider_id)[0];
          await this.loadData()
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false;
      }
    },
    printOrder() {
      // let routeData = this.$router.resolve({
      //   path: "/admin//reports/print-report-provider",
      // });
      // window.open(routeData.href, "_blank");
      window.print()
    },
  },
};
</script>
<style lang="scss">
.row.totals div {
  border: 1px solid #e3e3e3;
  padding: 4px 8px;
  display: flex;
  justify-content: space-between;
}

.font-bold {
  font-weight: bold !important;
}

</style>
